module.exports = __webpack_public_path__ + "static/media/rm_06-08.dcdc53bd.png";